import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home/Home";

import axios from "axios";
import ThanksPage from "./pages/thanks/ThanksPage";
import Activations from "./pages/Home/Activations";

//axios.defaults.baseURL = "http://localhost:6029/api/v1";
axios.defaults.baseURL = "https://api.chocodate.ae/api/v1";
axios.defaults.withCredentials = true;

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/thank-you" element={<ThanksPage />} />
        <Route path="/activations" element={<Activations />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
